export default __webpack_public_path__ + "static/media/patio-com2.dfc5d42b.jpg";